<template>
  <table :class="'table ' + service.layout">
    <thead>
      <tr>
        <th :class="classMap[col.field]" v-for="(col, i) in service.cols" :key="i" :style="{width:i==0?'5%':''}">
          <template v-if="types=='orderDetail'">
            <div>{{ col.title }}</div>
          </template>
          <template v-if="types=='index'">
            <div v-if="i>0">{{ col.title }}</div>
          </template>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, i) in service.rows" :key="i">
        <td :class="classMap[col.field]" :style="styleMap[col.field]" v-for="(col, j) in service.cols" :key="j">
           <template v-if="types=='orderDetail'">
            <div>{{ row[col.field] || col.default }}</div>
          </template>
          <template v-if="types=='index'">
            <div v-if="j>0">{{ row[col.field] || col.default }}</div>
          </template>
        </td>
        <td style="text-align:right;padding:5px">
          <van-button type="primary" size="mini" @click="toErrorCorrection(row)">纠错</van-button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import IndexStore from "../../store/Index";
export default {
  props: {
    service: Object,
    types:String
  },
  computed: {
    styleMap() {
      let styleMap = {};
      let style = this.service.cols.forEach((col) => {
        styleMap[col.field] = "";

        Object.keys(col.style).forEach((key) => {
          styleMap[col.field] += `${key}: ${col.style[key]};`;
        });
      });

      return styleMap;
    },
    classMap() {
      let classMap = {};
      let style = this.service.cols.forEach((col) => {
        classMap[col.field] = "";
        classMap[col.field] += col.class.join(" ");
      });

      return classMap;
    },
  },
  data() {
    return {
      _service: []
    };
  },
  methods:{
    toErrorCorrection(data){
      this.$router.push({
        path:'/errorCorrection',  
        query:{
          ProductTitle:data.ProductTitle,//产品名称
          ProductBrandName:data.ProductBrandName,//品牌名称
          ManuProductCode:data.ManuProductCode,//产品型号
          VehicleTypeId:IndexStore.state.VehicleTypeId,//车型ID
          vinCode:IndexStore.state.Vin,//vin码
          ProductId:data.ProductId,//产品ID
          BrandId:data.ProductBrandId//品牌ID
        }
      })
    },
  },
  mounted(){
    this._service = this.service
    console.log('tables',this._service);
    console.log(this.types);
  }
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  width: 100%;
  border: none;
  border-collapse: collapse;
  border-spacing: 0;
}
tr,
td,
th {
  border: none;
}
tr {
  height: 0.5rem;
}
tbody tr:nth-child(odd) {
  background: #fff;
}
tbody tr:nth-child(even) {
  background: rgba(239, 238, 238, 1);
}
thead {
  font-size: 0.24rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
  text-align: left;
  background: rgba(239, 238, 238, 1);
}
.ellipsis > div {
  // overflow: hidden;
  // text-overflow: ellipsis;
  // display: -webkit-box;
  // -webkit-box-orient: vertical;
  // -webkit-line-clamp: 2;
  padding: 0 0.2rem;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
td.red {
  color: red;
}
</style>
